/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
import _ from 'underscore';
import currencyFormatter from 'currency-formatter';

// Format a currency amount
//
// Assumes cents
export var formatCurrency = function(cents, currency) {
  if (currency == null) { currency = 'usd'; }
  const currencyData = currencyFormatter.findCurrency(currency.toUpperCase()) || currencyFormatter.findCurrency('USD');
  const cents_units = Math.pow(10, currencyData.decimalDigits);
  return currencyFormatter.format(cents / cents_units, {code: currencyData.code});
};

// Format a duration as minutes/seconds
export var formatDuration = function(duration) {
  const minutes = duration.minutes();
  let seconds = duration.seconds();
  if (seconds < 10) { seconds = `0${seconds}`; }

  return `${minutes}:${seconds}`;
};

// Returns true if +value+ is blank
export var isBlank = value => (value === null) ||
(value === undefined) ||
((typeof(value) === 'string') && !!value.match(/^\s*$/));

export var organizerTicketMailTo = (email, event_name) => {
  return `mailto:${email}?subject=Question%20about%20my%20ticket%20to%20${encodeURIComponent(event_name)}`;
};

// Make sure this in sync with registration.ticket_states in config/locales/en.yml
export var ticket_status_lookup = ticket_status => {
  const status_lookup = {
    pending: "Pending",
    purchased: "Purchased",
    checked_in: "Checked In",
    refunded: "Refunded",
    voided: "Cancelled",
    disputed: "In Dispute",
    dispute_lost: "Dispute Lost",
    cancelled: "Cancelled",
    refund_requested: "Refund Requested",
    refund_denied: "Refund Denied"
  };

  return status_lookup[ticket_status];
};

